export class Invoice {
  id: number;
  invoicingDate: Date;
  dueDate: Date;
  totalVATExcluded: number;
  totalVATIncluded: number;
}
